import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CalendarService } from '../../../../../app/services/calendar.service';
import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackCalendar } from '../../../../../app/models/dataPackCalendar.model';

/**
 * @version $Id: content.component.ts 79366 2018-02-17 00:40:37Z thiago.h.neri $
 */
@Component({
  selector: 'changeCalendarConfigModal',
  templateUrl: './content.template.html'
})
export class ChangeCalendarConfigModalComponent {

  @Input() type: string;
  
  constructor(private activeModal: NgbActiveModal) {

  }

  private close() {
    this.activeModal.dismiss();
  }

  private change() {
    this.activeModal.close();
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/calendar/changeConfig/content.component.ts